<template>
  <!-- 详情 -->
  <div>
    <Modal v-model="visible" title="审核" width="1000px" class="my-modal" :footer-hide="true">
      <Form v-if="visible" ref="myForm" :model="formData" :label-width="120" class="page-form">
        <div class="form-title">提现信息</div>
        <FormItem label="业务员姓名">
          {{ formData.userName }}
        </FormItem>
        <FormItem label="所属机构">
          {{ formData.orgName }}
        </FormItem>
        <FormItem label="所属团队">
          {{ formData.groupName }}
        </FormItem>
        <FormItem label="状态">
          <div class="tag">
            <span v-if="formData.okbStatus == '-2'" class="item not-started">待发放</span>
            <span v-else-if="formData.okbStatus == '0'" class="item processing">待提现</span>
            <span v-else-if="formData.okbStatus == '9'" class="item processing">银行处理中</span>
            <span v-else-if="formData.okbStatus == '3'" class="item processing">待审核</span>
            <span v-else-if="formData.okbStatus == '1'" class="item success">提现成功</span>
            <span v-else-if="[-1, 2].includes(formData.okbStatus * 1)" class="item ended">提现失败</span>
            <span v-else-if="formData.okbStatus == '99'" class="item ended">已冻结</span>
          </div>
        </FormItem>
        <div class="form-title">银行账户信息</div>
        <FormItem label="户主名称">
          {{ formData.userName }}
        </FormItem>
        <FormItem label="证件类型">
          {{ formData.cardType }}
        </FormItem>
        <FormItem label="证件号">
          <sensitiveView :data="formData" queryKey="userId" keyName="idNo" dataType="1" fun="50"></sensitiveView>
        </FormItem>
        <FormItem label="银行预留手机号">
          <sensitiveView :data="formData" queryKey="userId" keyName="mobile" dataType="8" fun="50"></sensitiveView>
        </FormItem>
        <FormItem label="开户银行">
          {{ formData.bank }}
        </FormItem>
        <FormItem label="银行账号">
          <sensitiveView :data="formData" queryKey="userId" keyName="cardNo" dataType="3" fun="50"></sensitiveView>
        </FormItem>

        <div class="form-title">明细</div>
        <FormItem label="待审核"> {{ formData.waitAmount }}元 </FormItem>
        <FormItem label="已提现"> {{ formData.withdrawAmount }}元 </FormItem>
        <FormItem label="已发放"> {{ formData.issuedAmount }}元 </FormItem>
      </Form>

      <Tabs v-model="searchParams.okbStatus" @on-click="queryOkbWithdrawDetail()">
        <TabPane label="待审核" name="3"></TabPane>
        <TabPane label="已提现" name="1"></TabPane>
        <TabPane label="已发放" name="0"></TabPane>
      </Tabs>

      <div class="table-box">
        <loading :isShow="listLoading" />
        <Table :columns="columns" :data="tableData" max-height="400">
          <template slot-scope="{ row }" slot="detail">
            <div>
              <span class="table-btn" @click="lookInvoice(row)">查看发票</span>
            </div>
          </template>
          <template slot-scope="{ row }" slot="action">
            <div>
              <span class="table-btn" @click="lookDetail(row)">明细</span>
            </div>
          </template></Table
        >
      </div>
      <!-- 已冻结才有按钮 -->
      <div class="ivu-modal-footer">
        <Button type="primary" ghost @click="visible = false">取消</Button>
        <Button v-if="searchParams.okbStatus == 3 && tableData.length" type="primary" @click="save">打款</Button>
        <Button v-if="searchParams.okbStatus == 3 && searchParams.invoiceConfig == 0 && tableData.length" type="primary" @click="rejectHandle">驳回</Button>
        <Button v-else-if='searchParams.invoiceConfig == 0' type="primary" @click="visible = false">确定</Button>
      </div>
    </Modal>
    <!-- 短信验证 -->
    <okbao-check ref="okbaoCheck" @reload="reload" />

    <invoiceModal ref='invoiceModalRef'/>
    <!-- 驳回 -->
    <reject-modal ref="rejectModal" @reload="reload" />
  </div>
</template>
  <script>
import filters from '@/api/filter';
import okbaoCheck from './okbaoCheck';
import rejectModal from './rejectModal';
import { pageTool, common } from '@/api/mixins';
import sensitiveView from '@/components/commons/sensitiveView';
import invoiceModal from './invoiceModal';
export default {
  mixins: [pageTool, common],
  components: {
    okbaoCheck,
    rejectModal,
    sensitiveView,
    invoiceModal
  },
  data: () => ({
    tableData: [],
    visible: false,
    formData: {},
    columns: [],
    searchParams: {}
  }),
  created() {},
  methods: {
    rejectHandle() {
      let ids = this.tableData.map(i => i.id);
      this.$refs.rejectModal.open({ ...this.formData, ids })
    },
    setColums() {
      let vm = this;
      let columns = [
        {
          title: '结算周期',
          align: 'center',
          render(h, params) {
            let settlementDate = params.row.settlementDate;
            return <span>{filters.filterTime(settlementDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '结算单名称',
          key: 'reportName',
          align: 'center'
        }
      ];
      if(this.searchParams.invoiceConfig == 0){
        columns.push({
          title: '发票',
          slot: 'detail',
          align: 'center'
        })
      }
      columns =  columns.concat([
      {
          title: '提现类型',
          align: 'center',
          render(h, params) {
            let withdrawType = params.row.withdrawType;
            return <span>{withdrawType == 2 ? '支付宝' : '银行卡'}</span>;
          }
        },
        {
          title: '税前合计(元)',
          key: 'totalIncome',
          align: 'center'
        },
        {
          title: '税后合计(元)',
          key: 'netIncome',
          align: 'center'
        },
        {
          key: 'okbStatus',
          align: 'center',
          renderHeader(h, params) {
            console.log(vm.searchParams.okbStatus);
            if (vm.searchParams.okbStatus == 3) {
              return <span>申请时间</span>;
            } else if (vm.searchParams.okbStatus == 1) {
              return <span>打款时间</span>;
            } else if (vm.searchParams.okbStatus == 0) {
              return <span>发放时间</span>;
            }
          },
          render(h, params) {
            if (vm.searchParams.okbStatus == 3) {
              return <span>{filters.filterTime(params.row.requestTime, 'YYYY-MM-DD HH:mm')}</span>;
            } else if (vm.searchParams.okbStatus == 1) {
              return <span>{filters.filterTime(params.row.paymentTime, 'YYYY-MM-DD HH:mm')}</span>;
            } else if (vm.searchParams.okbStatus == 0) {
              return <span>{filters.filterTime(params.row.createTime, 'YYYY-MM-DD HH:mm')}</span>;
            }
          }
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: 80
        }
      ])
      this.columns = columns;
    },
    lookInvoice(row){
      this.$refs.invoiceModalRef.open(row);
    },
    open(data) {
      data = JSON.parse(JSON.stringify(data));
      this.formData = data;
      this.searchParams = JSON.parse(
        JSON.stringify({
          userId: data.userId,
          okbStatus: data.okbStatus,
          invoiceConfig: data.invoiceConfig || ''
        })
      );
      this.queryOkbWithdrawDetail();
      this.visible = true;
    },
    // 查看明细
    lookDetail(row) {
      this.openPageTabTags('/financialManage/salesmanPaySettlement/detail', {
        reportId: row.reportId,
        tabVal: 1,
        userId: row.userId,
        pageType: 'withdrawalOK'
      });
    },
    queryOkbWithdrawDetail() {
      this.listLoading = true;
      this.tableData = [];
      this.$set(this.formData, 'issuedAmount', '');
      this.$set(this.formData, 'waitAmount', '');
      this.$set(this.formData, 'withdrawAmount', '');
      this.setColums();
      this.$http({
        url: '/buz/userCashWithdrawLog/queryOkbWithdrawDetail',
        type: 'POST',
        data: this.searchParams
      })
        .then(res => {
          this.listLoading = false;
          this.tableData = res.data.dataList;
          this.$set(this.formData, 'issuedAmount', res.data.issuedAmount);
          this.$set(this.formData, 'waitAmount', res.data.waitAmount);
          this.$set(this.formData, 'withdrawAmount', res.data.withdrawAmount);
        })
        .catch(err => {
          this.listLoading = false;
          console.log(err);
        });
    },
    // 冻结状态保存冻结原因
    save() {
      const params = {
        userIds: [this.searchParams.userId],
        operationType: 1,
        okbStatus: 3,
        idList: this.tableData.map(i => i.id)
      };

      this.$refs.okbaoCheck.open(params);
    },
    // 成功回调
    reload() {
      this.visible = false;
      this.$emit('reload');
    }
  }
};
</script>
  <style lang='scss' scoped>
.tag {
  justify-content: flex-start !important;
}
</style>